import React,  { useState } from 'react';
import { find, sum } from 'lodash';
import ReactTable from 'react-table';
import Box from '../../common/Box';
import IncrementalLineChart from '../../widgets/charts/types/IncrementalLineChart';
import DoughnutChart from '../../widgets/charts/types/DoughnutChart';
import StackedBarChart from '../../widgets/charts/types/StackedBarChart';
import countriesByAbbreviation from '../../common/CountriesByAbbreviation';
import CSV from '../../../helpers/CSVExport';
import { splitByThousands } from '../../../helpers/NumberFormatter';
import { formatTooltipLabelDoughnutWithPercentage, formatTooltipLabelWithCurrency } from '../../widgets/charts/Formatter';
import { territoriesBar, territoriesLine, territoriesPie } from '../../widgets/charts/ChartDefaults';

var pieSvg = require('!svg-inline-loader!../../../../public/img/pie.svg');
var lineSvg = require('!svg-inline-loader!../../../../public/img/line.svg');
var tableSvg = require('!svg-inline-loader!../../../../public/img/table.svg');
var barSvg = require('!svg-inline-loader!../../../../public/img/chart-bar.svg');
var downloadSvg = require('!svg-inline-loader!../../../../public/img/download.svg');

const toolbarChartViewIcons = {
		table: tableSvg,
		line: lineSvg,
		pie: pieSvg,
		bar: barSvg
}

export default function Sources(props) {
	const [mode, setMode] = useState('bar');
	
	const { table = [] } = props;
	const { period, physical, digital, nr, loading } = props.results || {};
	
	const getTimeseries = () => {
		return  {
			labels: period,
			datasets: [
				{label: 'Physical', data: physical, backgroundColor: "#3466CB", borderColor: "#3466CB",
        pointBackgroundColor: "#3466CB",
        pointBorderColor: "#3466CB" },
				{label: 'Digital', data: digital, backgroundColor: "#FF9900", borderColor: "#FF9900",
        pointBackgroundColor: "#FF9900",
        pointBorderColor: "#FF9900" },
				{label: 'Neighboring Rights', data: nr, backgroundColor: "#159619", borderColor: "#159619",
        pointBackgroundColor: "#159619",
        pointBorderColor: "#159619" },
			]
		};
	}
	
	const exportToCsv = () => {
		let data = table.map(row => {
		  return {
			period: row.period,
			physical: row.physical,
			digital: row.digital,
			neighboring_rights: row.nr
		  };
		});
		const filename = CSV.CSVHeader('revenue_streams', ''); 
		return CSV.CSVExport(data, {filename}, 'revenue_streams');
	}

	
	const getPie = () => {
		let dataset = [
			sum(physical),
			sum(digital),
			sum(nr)
		], 
		labels = ['Physical', 'Digital', 'Neighboring Rights'];
		return {
			labels: labels,
			datasets: [{
				data: dataset, label: 'revenue', backgroundColor: ["#3466CB", "#FF9900", "#159619"]
			}]
		};		
	}
	
	const getTable = () => {
		const commonColumnProps = {
			// className: 'table-text-right', 
			// headerClassName: 'table-text-right',
		};
		let columns = [
			{
				id: 'period',
				accessor: 'period',
				Header: 'Period',
				...commonColumnProps
			},
			{
				id: 'physical',
				accessor: 'physical',
				Header: 'Physical',
				Cell: props => <span>{splitByThousands(props.value, '$')}</span>,
				...commonColumnProps
			},
			{
				id: 'digital',
				accessor: 'digital',
				Header: 'Digital',
				Cell: props => <span>{splitByThousands(props.value, '$')}</span>,
				...commonColumnProps
			},
			{
				id: 'nr',
				accessor: 'nr',
				Header: 'Neighboring Rights',
				Cell: props => <span>{splitByThousands(props.value, '$')}</span>,
				...commonColumnProps
			},

		];
		return <ReactTable 
			className=""
			data={table} 
			columns={columns}
			defaultPageSize={10}
			showPagination={true}        	
		/>
	}
	
	const renderToolbar = () => {
		let toolbar = [];
		let views = {
			'table': 'table',
			'line': 'chart-line',
			'bar': 'chart-bar',
			'pie': 'chart-pie'
		}
		for (let view in views) {
			toolbar.push(<a key={view} className={`chart-icon ${mode == view? 'active' : ''}`} onClick={()=>setMode(view)} dangerouslySetInnerHTML={{__html: toolbarChartViewIcons[view]}}></a>);
		}
		toolbar.push(<a key='download' className="chart-icon" onClick={()=>exportToCsv()} dangerouslySetInnerHTML={{__html: downloadSvg}}></a>);
		return toolbar;
	}
	
	return <Box title={`Revenue Streams`} spinnerEnabled={loading} toolbar={renderToolbar()} className="home-box">
		{period && <div className="chart-block">
			{mode == 'line' && <IncrementalLineChart data={getTimeseries()} options={territoriesLine()} 
			chartID="territories_report_sources_chart" />}
			{mode == 'bar' && <StackedBarChart data={getTimeseries()} isCustomWidth={true} options={territoriesBar()} chartID="territories_report_sources_chart" />}
			{mode == 'pie' && <DoughnutChart data={getPie()} options={territoriesPie} chartID="territories_report_sources_chart" />}
			{mode == 'table' && getTable()}
		</div>}
	</Box>
}